import React from 'react'

export default function usePevious(value) {
  const ref = React.useRef()
  React.useEffect(() => {
    ref.current = value
  })

  return ref.current
}
